export enum FilterTimePeriod {
  TODAY = "TODAY",
  LAST_SEVEN_DAYS = "LAST_SEVEN_DAYS",
  LAST_30_DAYS = "LAST_30_DAYS",
  LAST_90_DAYS = "LAST_90_DAYS",
  LAST_180_DAYS = "LAST_180_DAYS"
}
